/*
  FV の直下の紹介動画 (components/PrVideoSection.tsx) の CSS。
  PC は 16:9 を最大 1040px で中央に、スマホは 9:16 (高さ 72vh 以下、幅はそれに合わせる) で中央に。側の余白は 16px。
  角は HP の枠の決まり (6px) に合わせ、影と枠は足さない。上の余白だけ持ち、下は次の節 (AboutScope) の上の余白に任せる。
  ポスターと動画は同じ箱 (.hx-prv) に重ね、動画は流れ始めてから (data-playing) 出す。
  箱の下の操作バー (.hx-prv-bar) はレッスン動画と同じ ControlBar (@noiman/ui/video)。色は緑の着せ替え (進みと印 #05B45B、字 #14231A、
  フォーカスの輪は --focus-ring) に合わせ、Tailwind の色の名前 (text-main など) を持たない HP のため、字の色と触ったときの地をここで決める。
  バーは動画が画面に入ったか触れたときに描く (それまでは丸い止めるボタン) ので、描く前から高さを空けておく (狭い形 2 行、PC 1 行)。動きを減らす設定では動画を付けないのでバーも出さない。
  全画面は card (.hx-prv-card) ごと。映像とバーは画面の高さに入る幅 (--fs-w) にそろえる。縦の動画 (data-side=sp) は縦の比のまま
*/
export const PRVIDEO_CSS = `
.hp .hx-sec.hx-prv-sec{padding:var(--sec) 16px 0}
.hp .hx-prv-card{position:relative;margin:0 auto;width:min(calc(72vh * 9 / 16),100%)}
.hp .hx-prv-card:focus{outline:none}
.hp .hx-prv{position:relative;width:100%;aspect-ratio:9/16;border-radius:6px;overflow:hidden;background:var(--cream)}
.hp .hx-prv picture{display:block;position:absolute;inset:0}
.hp .hx-prv .hx-prv-img{position:absolute;inset:0;display:block;width:100%;height:100%;max-width:none;object-fit:cover}
.hp .hx-prv video{opacity:0}
.hp .hx-prv video[data-playing]{opacity:1}
.hp .hx-prv .hx-prv-btn{position:absolute;left:16px;bottom:16px;z-index:1;display:grid;place-items:center;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:#14231A;cursor:pointer}
.hp .hx-prv .hx-prv-btn[hidden]{display:none}
.hp .hx-prv .hx-prv-btn:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}
.hp .hx-prv .hx-prv-btn svg{display:block}
.hp .hx-prv .hx-prv-btn svg.hx-prv-ic-play,.hp .hx-prv .hx-prv-btn[data-paused] svg.hx-prv-ic-pause{display:none}
.hp .hx-prv .hx-prv-btn[data-paused] svg.hx-prv-ic-play{display:block}
.hp .hx-prv-bar{--pl-accent:#05B45B;--pl-ink:#14231A;--pl-focus:var(--focus-ring,#037F40);min-height:102px;color:#14231A}
.hp .hx-prv-bar[hidden]{display:none}
.hp .hx-prv-bar .pl-bar button{color:#14231A}
.hp .hx-prv-bar .pl-bar button:hover{background:#F0EEE3}
@media (min-width:768px){
  .hp .hx-prv-card{width:100%;max-width:1040px}
  .hp .hx-prv{aspect-ratio:16/9}
  .hp .hx-prv-bar{min-height:72px}
}
@media (prefers-reduced-motion:reduce){
  .hp .hx-prv-bar{display:none}
}
.hp .hx-prv-card:fullscreen{--fs-w:min(100vw,calc((100vh - 84px) * 16 / 9));display:flex;flex-direction:column;justify-content:center;width:100vw;max-width:none;margin:0;background:#fff}
.hp .hx-prv-card[data-side="sp"]:fullscreen{--fs-w:min(100vw,calc((100vh - 84px) * 9 / 16))}
.hp .hx-prv-card:fullscreen .hx-prv{width:var(--fs-w);margin:0 auto;border-radius:0;aspect-ratio:16/9}
.hp .hx-prv-card[data-side="sp"]:fullscreen .hx-prv{aspect-ratio:9/16}
.hp .hx-prv-card:fullscreen .hx-prv-bar{width:var(--fs-w);min-height:0;margin:0 auto}
`;
